import { render, staticRenderFns } from "./passkey_authentication.vue.js?vue&type=template&id=a54cf9ae!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./passkey_authentication.vue?vue&type=template&id=a54cf9ae"
import script from "./passkey_authentication.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./passkey_authentication.vue?vue&type=script&lang=js"
export * from "./passkey_authentication.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./passkey_authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54cf9ae')) {
      api.createRecord('a54cf9ae', component.options)
    } else {
      api.reload('a54cf9ae', component.options)
    }
    module.hot.accept("./passkey_authentication.vue.js?vue&type=template&id=a54cf9ae!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./passkey_authentication.vue?vue&type=template&id=a54cf9ae", function () {
      api.rerender('a54cf9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "authentication/sessions/components/passkey_authentication.vue"
export default component.exports